<template>
  <scroll-center-dialog v-model="opened" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-card-text>

      <v-text-field v-model="value.date_started"
                    :error="hasError('date_started')"
                    :error-messages="getError('date_started')"
                    label="Дата начала"
                    outlined
                    type="date"
      ></v-text-field>

      <v-text-field v-model="value.date_ended"
                    :error="hasError('date_ended')"
                    :error-messages="getError('date_ended')"
                    label="Дата конца"
                    outlined
                    type="date"
      ></v-text-field>

      <v-checkbox v-model="value.exclude"
                  :error="hasError('exclude')"
                  :error-messages="getError('exclude')"
                  outlined
                  label="Является ли выходным"
      ></v-checkbox>

      <v-checkbox v-model="value.vaccinated"
                  :error="hasError('vaccinated')"
                  v-show="false"
                  :error-messages="getError('vaccinated')"
                  label="Запись для вакцинированного"
                  outlined
      ></v-checkbox>

      <v-text-field v-model="value.start_intervals"
                    :error="hasError('start_intervals')"
                    :error-messages="getError('start_intervals')"
                    label="Время начала "
                    outlined
                    type="time"
      ></v-text-field>

      <v-text-field v-model="value.end_intervals"
                    :error="hasError('end_intervals')"
                    :error-messages="getError('end_intervals')"
                    label="Время конца"
                    outlined
                    type="time"
      ></v-text-field>


      <v-alert v-if="hasError('non_field_errors')" type="error">
        {{ getError('non_field_errors') }}
      </v-alert>
      <v-alert v-if="hasError('detail')" type="error">
        {{ getError('detail') }}
      </v-alert>
      <v-alert v-if="hasError('error')" type="error">
        {{ getError('error') }}
      </v-alert>
    </v-card-text>
  </scroll-center-dialog>
</template>

<script>
import UserDataFormMixin from '@/mixins/UserDataFormMixin'
import {loadData} from "@/helper/requests";
import urls from '@/urls/helper.js'
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog.vue";
import {mapActions} from "vuex";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";

export default {
  name: "Courses",
  components: {ScrollCenterDialog},
  mixins: [FormErrorsMixin],
  props: {
    opened: Boolean,
    edit: Boolean,
    docs_data: Object,
    user: Object,
    event: Number,
  },
  data() {
    return {
      value: {
        id: null,
        event:  undefined,
        week_day:  undefined,
        date_started: undefined,
        date_ended: undefined,
        exclude: false,
        vaccinated: false,
        start_intervals: undefined,
        end_intervals: undefined,
      },
    }
  },
  computed: {
    form_title() {
      return this.docs_data  ? 'Редактировать' : 'Добавить'
    },
  },
  methods: {
    ...mapActions({
      createData: 'date/createDate',
      changeData: 'date/changeDate',
      detailData: 'date/loadDateDetail'
    }),

    save() {
      if (this.value.id) {
        this.changeData({
          event: this.event,
          id: this.value.id,
          data: this.value,
          finalizer: (val) => {
            this.$emit('close', val)
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      } else {
        this.createData({
          event: this.event,
          data: this.value,
          finalizer: (val) => {
            this.$emit('close', val)
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
    },
    close() {
      this.$emit('close', false)
    },
  },
  created() {
    if (this.docs_data) {
      this.detailData({
        event: this.event,
        id: this.docs_data.id,
        finalizer: (val) => {
          this.value = JSON.parse(JSON.stringify(val))
        },
        catcher: (val) => {
          this.mapErrors(val)
        },
      })
    }
  }
}
</script>

<style scoped>
</style>
